import { fetchHostInvoices } from '@/services/hostInvoices/hostInvoicesService'
const state = {
    hostInvoices: [],
}

const getters = {
    hostInvoices: (state) => state.hostInvoices,
}

const actions = {
  async fetchHostInvoices({ commit, dispatch}, hostId) {
    commit('setIsLoading', true)
    try {
      const { data } = await fetchHostInvoices(hostId)
      commit('setHostInvoices', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
    setHostInvoices: (state, hostInvoices) => {
        state.hostInvoices = hostInvoices
    },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
